import React from 'react';
import {Label} from 'reactstrap';
import FormRadio from '../../components/Common/FormRadio';

const SERVICE_OPTIONS = [
  {type: '50k, 150k, 250k etc. Service', part: '', name: 'GTX300NC PREVENT. MAINTENANCE 50K/150K/250K KIT'},
  {type: '100k, 200k, 300k etc. Service', part: '', name: 'GTX300NC PREVENT. MAINTENANCE 100K/200K/300K KIT'},
];

const Gtx300ncServices = () => {
  return (
    <>
      <Label htmlFor="service_type" className="col-form-label">
        Choose a service *
      </Label>

      {SERVICE_OPTIONS.map(({type, part, name}) => {
        return (
          <div
            key={type}
            className={`service-option mb-2 form-control`}
          >
            <FormRadio
              name="service_type"
              label={type}
              value={type}
            />
            <p className="mb-0 pl-4">
              {name}
              <br/>
              <span className="text-yellow">{part}</span>
            </p>
          </div>
        );
      })}
    </>
  );
};

export default Gtx300ncServices;
